import Button from "../../components/Button";
import Icon from "../../components/Icon";
import Indicator from "../../components/Indicator";

/**
 * SelectPatientTypeModal
 * 
 * A modal for selecting the patient type (Thai or Foreigner).
 * Step 1 of the registration process.
 * 
 * @param {object} props
 * @param {boolean} props.isOpen - Controls the visibility of the modal.
 * @param {function} props.onNext - Callback fired when the user selects a patient type.
 */
export default function SelectPatientTypeModal({
    isOpen,
    onNext,
    onClose,
}) {

    if (!isOpen) return null;

    const steps = [
        { id: 1, label: "ระบุประเภทผู้ป่วย" },
        { id: 2, label: "ข้อมูลผู้ป่วย" },
        { id: 3, label: "การคัดกรองเบื้องต้น" },
    ];

    const currentStep = 1;

    function handleSelectType(patientType) {
        if (onNext) {
            onNext(patientType);
        }
    }

    function buildHeader() {
        return (
            <div className="flex flex-col gap-5">
                <div className="flex justify-between items-start">
                    <div className="gap-2 flex flex-col">
                        <p className="font-ui font-header text-title text-main-typography-system-default">การลงทะเบียนผู้ป่วย</p>
                        <p className="font-ui font-body text-body-base text-main-typography-system-description">ลงทะเบียนหรือระบุผู้ป่วยก่อนการคัดกรอง</p>
                    </div>
                    {onClose && (
                        <Button
                            hierarchy="tertiary"
                            size="md"
                            icon="x"
                            onClick={onClose}
                        />
                    )}
                </div>
                <Indicator steps={steps} currentStep={currentStep} />
            </div>
        );
    }

    function buildTypeCard(type, iconName, title, description) {
        return (
            <div
                onClick={() => handleSelectType(type)}
                className="rounded-lg border-focus-ring p-6 gap-5 bg-main-background-system-default border-main-border-system-default flex flex-col items-center justify-center cursor-pointer hover:border-creation-primary-container-on-surface-default"
            >
                <div className="w-9 h-9 rounded-sm p-2 gap-3 flex items-center justify-center bg-main-background-accented-primary">
                    <Icon name={iconName} size="xl" className="text-main-icon-accented-primary" />
                </div>
                <div className="text-center flex flex-col">
                    <p className="font-ui font-header text-body-base text-main-typography-system-default">
                        {title}
                    </p>
                    <p className="font-ui font-body text-body-small text-main-typography-system-description">
                        {description}
                    </p>
                </div>
            </div>
        );
    }

    function buildSelectionSection() {
        return (
            <div className="flex flex-col gap-5">
                <p className="font-ui font-header text-body-base text-main-typography-system-default">ระบุประเภทผู้ป่วย</p>
                <div className="grid grid-cols-2 gap-3">
                    {buildTypeCard(
                        "thai",
                        "identification",
                        "ชาวไทย",
                        "อ่านบัตรหรือกรอกเลขบัตรประชาชน"
                    )}
                    {buildTypeCard(
                        "foreign",
                        "globe-alt",
                        "ชาวต่างชาติ",
                        "กรอกเลขหนังสือเดินทาง"
                    )}
                </div>
            </div>
        );
    }

    return (
        <div className="modal-scroll modal-scroll-no-outer">
            <div className="modal-dialog w-[720px] rounded-xl p-5 gap-6 flex flex-col bg-main-background-system-default">
                {buildHeader()}
                {buildSelectionSection()}
            </div>
        </div>
    );
}
